import React, { useState } from "react";
import { Button, Card } from "react-bootstrap";
import { formatCurrency } from "@/lib/currency/currency";
import { Icon } from "@/components";
import { SpaceLayout } from "@/data";

interface SelectSpaceLayoutStepProps {
  onNext: (layoutId: string) => void;
  layouts: SpaceLayout[];
  currency: string | null;
  value?: string;
}

export function SelectSpaceLayoutStep({
  onNext,
  layouts,
  currency,
  value,
}: SelectSpaceLayoutStepProps) {
  const [selectLayoutId, setSelectedLayoutId] = useState(value);

  const hasAllSamePrice = layouts.every(
    (l) =>
      l.priceRanges.hourly?.lowestPrice ===
        layouts[0]?.priceRanges.hourly?.lowestPrice &&
      l.priceRanges.daily?.lowestPrice ===
        layouts[0]?.priceRanges.daily?.lowestPrice
  );

  return (
    <div className="">
      <div style={{ display: "grid", gridTemplateColumns: "50% 50%" }}>
        {layouts.map((l) => (
          <Card
            key={l.id}
            className="m-1"
            onClick={() => setSelectedLayoutId(l.id)}
            border={selectLayoutId === l.id ? "primary" : undefined}
            role="button"
          >
            <SpaceLayoutOption
              imgSrc={l.imageURL}
              layout={l.name}
              hourPrice={l.priceRanges.hourly?.lowestPrice}
              dailyPrice={l.priceRanges.daily?.lowestPrice}
              currency={currency}
              maxGuests={l.capacity}
              hidePrice={hasAllSamePrice}
            />
          </Card>
        ))}
      </div>
      <Button
        variant="outline-primary"
        className="mt-3 p-2"
        onClick={() => selectLayoutId && onNext(selectLayoutId)}
        data-testid="event-space-select-layout-next-step"
      >
        Next step
      </Button>
    </div>
  );
}

interface SpaceLayoutOptionProps {
  imgSrc: string;
  layout: string;
  hourPrice?: number;
  dailyPrice?: number;
  currency: string | null;
  maxGuests: number;
  hidePrice: boolean;
}

function SpaceLayoutOption({
  imgSrc,
  layout,
  hourPrice,
  dailyPrice,
  currency,
  maxGuests,
  hidePrice,
}: SpaceLayoutOptionProps) {
  const priceText =
    hourPrice && dailyPrice
      ? `From ${formatCurrency(hourPrice, currency)}/hour or ${formatCurrency(
          dailyPrice,
          currency
        )}/day`
      : hourPrice
      ? `From ${formatCurrency(hourPrice, currency)}/hour`
      : dailyPrice
      ? `From ${formatCurrency(dailyPrice, currency)}/day`
      : undefined;

  return (
    <div style={{ width: "fit-content", padding: 12 }}>
      <div className="d-flex align-items-center justify-content-center">
        <img src={imgSrc} alt={layout} className="w-100" />
      </div>

      <div className="fw-semibold mt-2">{layout}</div>
      {!hidePrice && <div className="mt-3">{priceText}</div>}
      <div className="mt-1">
        <Icon name="people" size={16} /> Up to {maxGuests} guests
      </div>
    </div>
  );
}
